import { useCallback } from 'react';

export const useValidate = dateError => useCallback(({ from, to }) => {
    if (from > to) {
        return { to: dateError, from: dateError };
    }
}, [dateError]);
